import React, { useState } from 'react';
import { useForm } from 'react-final-form';
import { useDispatch, useSelector } from 'react-redux';

import useWizardContext from '@swf/core/hooks/useWizardContext';
import { select } from '@swf/core/store';
import type { Dispatch } from '@swf/core/store';

import type { PaySystemDetails } from '../../../../../../types/Cashier';
import { getPaySystemName } from '../../../../../../utils/cashier';
import Checkbox from '../../../../../Checkbox/Checkbox';
import PaymentMethodLogo from '../../../../../PaymentMethodLogo/PaymentMethodLogo';
import Prompt from '../../../../../Prompt/Prompt';
import Info from '../../../Info/Info';

import {
  TXTWCL_Continue_to_deposit,
  TXTWCL_Deposit_another_way,
  TXTWCL_DonXt_show_this_again,
  TXTWCL_Important_Notice
} from './PaySystemInfoPrompt.messages.json';
import { content, infoMessage } from './PaySystemInfoPrompt.scss';

interface Props {
  paySystemDetails: PaySystemDetails;
  callback: () => void;
}

const PaySystemInfoPrompt: React.FC<Props> = ({ paySystemDetails: { msg, type }, callback }) => {
  const { localSettings } = useDispatch<Dispatch>();
  const paysystemMessages = useSelector(select.localSettings.getCashier)?.paysystemMessages;
  const {
    data: { paySystems }
  } = useWizardContext();
  const form = useForm();
  const [checked, setChecked] = useState(false);
  const systemName = getPaySystemName(paySystems, type);
  const toggleChecked = () => setChecked((previousValue) => !previousValue);

  const onConfirm = () => {
    if (checked) {
      if (paysystemMessages) {
        paysystemMessages[type] = msg;
        localSettings.set({
          cashier: {
            paysystemMessages
          }
        });
      } else {
        localSettings.set({
          cashier: {
            paysystemMessages: {
              [type]: msg
            }
          }
        });
      }
    }

    form.submit();
  };

  return (
    <Prompt
      variant="default"
      title={{ translation: TXTWCL_Important_Notice }}
      primaryButton={{ translation: TXTWCL_Continue_to_deposit }}
      secondaryButton={{ translation: TXTWCL_Deposit_another_way }}
      onPrimaryButtonClick={onConfirm}
      onSecondaryButtonClick={callback}
      onClose={callback}
    >
      <div className={content}>
        {type ? <PaymentMethodLogo cardType={type} i18nSystemName={systemName} /> : null}
        {msg ? <Info message={msg} className={infoMessage} /> : null}
        <Checkbox checked={checked} onChange={toggleChecked} label={TXTWCL_DonXt_show_this_again} />
      </div>
    </Prompt>
  );
};

export default PaySystemInfoPrompt;
